module.exports = __webpack_public_path__ + "img/basketball_w.166c9e3f.svg";